<div class="card-info">
    <mat-icon
        class="credit-card-provider-logo"
        role="img"
        [attr.aria-hidden]="false"
        [attr.aria-label]="creditCardLabel()"
        [svgIcon]="creditCardIcon()"
    ></mat-icon>
    <p class="card-text body-1">ending with {{ lastFourDigits() }}</p>
</div>
